import React, { useEffect, useState } from "react";
import Button from "../form/Button";
import { classNames } from "../../helpers/classNames";
import EligibilityPassedContent from "./EligibilityPassedContent";
import EligibilityFailedContent from "./EligibilityFailedContent";
import useFetch from "../../hooks/useFetch";
import { atemptQuiz, quizDetails } from "../../services/quizService";
import { toast } from "react-toastify";
import QuizAnswerButton from "./QuizAnswerButton";
import useMutation from "../../hooks/useMutation";
import { useLocation, useNavigate } from "react-router-dom";
import ApplicationModalFront from "../sections/front/Apply/modals/ApplicationModalFront";
import { useSelector } from "react-redux";

const QuizItem = ({ data = {}, onAnswer = () => {}, selectedAnswer = {} }) => {
  return (
    <div className="w-full space-y-8">
      <div className="text-lg font-semibold mb-4 w-full mx-auto text-center">
        {data?.question}
      </div>
      <div className="flex flex-wrap gap-4 justify-center">
        {data?.options?.map((opt, i) => (
          <QuizAnswerButton
            key={i?.toString()}
            data={opt}
            selectAnswerHandler={(e) => onAnswer({ ...e, question: data })}
          />
        ))}
      </div>
    </div>
  );
};

const EligibilityQuizContent = ({
  data = {},
  okHandler = () => {},
  setApplicationModal = () => {},
  setAction = () => {},
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);

  const [selectedAnswer, setSelectedAnswer] = useState({
    questionId: null,
    answerId: null,
  });

  const {
    data: quizData,
    error,
    isLoading,
    isFetching,
    refetch: quizRefetch,
    updateData,
  } = useFetch({
    dependencies: ["quiz-details", data?.quizeId, data?._id],
    fetchFunction: async () => {
      const res = await quizDetails({
        id: data?.quizeId,
        nonApplyQuestionId: true,
        scholarshipId: data?._id,
      });
      if (res?.status === 200) {
        return {
          ...res?.data,
          note: "Please answer honestly—accuracy matters.",
          quizzes: res?.data?.questionId
            .map((id) =>
              res?.data?.questionDetails.find((item) => item._id === id)
            )
            ?.map((item, i) => ({
              ...item,
              options: item?.options?.map((op) => ({ ...op, checked: false })),
              question: item?.title,
            })),
          // quizzes: res?.data?.questionDetails?.map((item, i) => ({
          //   ...item,
          //   options: item?.options?.map((op) => ({ ...op, checked: false })),
          //   question: item?.title,
          // })),
        };
      } else {
        toast.warning(res?.message);
        return {};
      }
    },
    enabled: !!data?.quizeId,
  });

  const {
    mutate: handleNext,
    isPending: ansSubmitionPending,
    data: sumbitAns,
    clearData: removePreviousAns,
  } = useMutation({
    mutationFn: async () => {
      const payload = {
        scholarshipId: data?._id,
        questionId: selectedAnswer?.questionId,
        answerId: selectedAnswer?.answerId,
        quizeId: data?.quizeId,
      };
      const res = await atemptQuiz(payload);
      return res;
    },
    onSuccess: async (res) => {
      if (res?.status === 200 || res?.status === 201) {
        if (res?.data?.answerInfoData?.correct) {
          updateData((pre) => {
            pre.quizzes = pre.quizzes.filter(
              (quiz) => quiz?._id !== selectedAnswer?.questionId
            );
            pre.questionDetails = pre.questionDetails.filter(
              (quiz) => quiz?._id !== selectedAnswer?.questionId
            );
            pre.questionId = pre.questionId.filter(
              (quiz) => quiz !== selectedAnswer?.questionId
            );
            if (res?.data?.isQualified) {
              pre.isQualified = res?.data?.isQualified;
            }
            return { ...pre };
          });
          setSelectedAnswer(null);
          return;
        }
        // if (!res?.data?.answerInfoData?.correct) {
        //   quizRefetch();
        //   return;
        // }
      } else {
        toast.warning(res?.message || res?.error || "something went wrong");
      }
    },
  });

  function answerSelectionHandler(val) {
    updateData((pre) => {
      pre.quizzes = pre.quizzes?.map((item) =>
        item?._id === val?.question?._id
          ? {
              ...item,
              options: item?.options?.map((op) =>
                op?._id === val?.answer
                  ? { ...op, checked: true }
                  : { ...op, checked: false }
              ),
            }
          : item
      );
      return { ...pre };
    });
    setSelectedAnswer({
      questionId: val?.question?._id,
      answerId: val?.answer,
    });
    removePreviousAns();
  }

  function onRetakeHandler() {
    quizRefetch().then(({ res }) => {
      if (res?._id) {
        setSelectedAnswer({ answerId: null, questionId: null });
        removePreviousAns();
      } else {
        toast.warning("something went wrong.");
      }
    });
  }

  if (session?.status === "unauthorized") {
    return (
      <div className="space-y-4">
        <div className="text-center mb-7 mt-5 text-xl">To apply, you’ll need an account.</div>
        <div className="flex items-center justify-center gap-3">
          <Button
            buttonLabel={"Close"}
            buttonFunction={okHandler}
            buttonClasses={classNames("!h-10 xl:!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-36")}
            buttonLabelClasses="!text-base xl:!text-xl"
          />
          <Button
            buttonLabel={"Continue"}
            buttonFunction={() => {
              navigate(`/authentication?callback=${location?.pathname}`);
            }}
            buttonClasses={classNames("!h-10 xl:!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-36")}
            buttonLabelClasses="!text-base xl:!text-xl"
          />
        </div>
      </div>
    );
  }

  if (!data?.quizeId) {
    return (
      <div className="text-center font-semibold">
        No quizes are currently available for this scholarship
      </div>
    );
  }

  if (isLoading || isFetching) {
    return <div className="text-center font-semibold">Loading...</div>;
  }

  if (
    (quizData?.isQualified === false || quizData?.isQualified === undefined) &&
    (quizData?.quizzes?.length === 0 || quizData?.totalnumberOfQuestions === 0)
  ) {
    return (
      <div className="text-center font-semibold">
        No questions for this scholarship
      </div>
    );
  }

  if (quizData?.attemptsLeft <= 0) {
    return (
      <div className="text-center font-semibold">
        You've reached the maximum number of attempts.
      </div>
    );
  }

  if (quizData?.isQualified || sumbitAns?.data?.isQualified) {
    return (
      <EligibilityPassedContent
        okHandler={okHandler}
        applyHandler={() => {
          okHandler();
          setApplicationModal({
            isOpen: true,
            data: data,
          });
          setAction(false);
        }}
      />
    );
  }

  return (
    quizData?.totalnumberOfQuestions > 0 && (
      <>
        {!quizData?.isQualified &&
          !sumbitAns?.data?.isQualified &&
          ((sumbitAns?.data && sumbitAns?.data?.answerInfoData?.correct) ||
            !sumbitAns?.data) && (
            <div className="relative">
              <div className="">{quizData?.note}</div>
            <div className="relative bg-catskill-white rounded-2xl pt-16 pb-11 px-8 mt-5">
              <div className="border-b border-dashed border-slate-400 mb-8">
                <div className="absolute top-5 left-4 font-CanelaDeck font-bold text-sm tracking-wider flex items-center gap-1 rounded-full text-white px-3 py-1 bg-chestnut-rose">
                  Attempts Left : <span>{quizData?.attemptsLeft}</span>
                </div>
                <div className="absolute top-5 right-4 font-CanelaDeck font-bold text-sm tracking-wider">
                  {quizData?.totalnumberOfQuestions -
                    quizData?.quizzes?.length +
                    1}
                  /{quizData?.totalnumberOfQuestions || 0}
                </div>
              </div>
                
                <QuizItem
                  data={quizData?.quizzes[0]}
                  onAnswer={answerSelectionHandler}
                  selectedAnswer={selectedAnswer}
                />
                <div className="flex justify-center mt-8">
                  <Button
                    buttonLabel={"Next"}
                    buttonFunction={handleNext}
                    {...(ansSubmitionPending && {
                      buttonIcon:
                        "fa-duotone fa-solid fa-spinner-third animate-spin !text-base xl:!text-xl",
                      buttonIconPosition: "left",
                    })}
                    isDisable={ansSubmitionPending || !selectedAnswer?.answerId}
                    buttonClasses={classNames(
                      "!h-10 xl:!h-12 !rounded-full !px-6 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-40",
                      !selectedAnswer?.answerId ? "!opacity-20" : "",
                      ansSubmitionPending && "opacity-80"
                    )}
                    buttonLabelClasses="!text-base xl:!text-xl"
                  />
                </div>
              </div>
            </div>
          )}
        {sumbitAns?.data && !sumbitAns?.data?.answerInfoData?.correct && (
          <EligibilityFailedContent
            onRetake={onRetakeHandler}
            loading={isLoading || isFetching}
            okHandler={okHandler}
          />
        )}
      </>
    )
  );
};

export default EligibilityQuizContent;
